import { jsx as o, jsxs as p } from "@emotion/react/jsx-runtime";
import s from "@mui/icons-material/CheckBox";
import a from "@mui/icons-material/CheckBoxOutlineBlank";
import m from "@mui/material/Autocomplete";
import h from "@mui/material/Checkbox";
import x from "@mui/material/TextField";
const O = /* @__PURE__ */ o(a, { fontSize: "small" }), f = /* @__PURE__ */ o(s, { fontSize: "small" });
function j({
  options: n,
  itemSelected: r,
  value: i,
  labelText: l,
  placeholderText: c,
  disabled: d
}) {
  return /* @__PURE__ */ o(
    m,
    {
      disabled: d,
      "data-testid": "nurse-multi-select",
      onChange: (e, t) => {
        r(t);
      },
      multiple: !0,
      options: n,
      disableCloseOnSelect: !0,
      value: i,
      getOptionLabel: (e) => e.title,
      isOptionEqualToValue: (e, t) => e.id === t.id,
      renderOption: (e, t, { selected: u }) => /* @__PURE__ */ p("li", { ...e, children: [
        /* @__PURE__ */ o(h, { icon: O, checkedIcon: f, sx: { mr: 1 }, checked: u }),
        t.title
      ] }),
      renderInput: (e) => /* @__PURE__ */ o(x, { ...e, label: l, placeholder: c })
    }
  );
}
export {
  j as A
};
